import React from "react";
import PropTypes from "prop-types";
import { Cc } from "@washingtonpost/wpds-assets";
import { Button, Icon, styled } from "@washingtonpost/wpds-ui-kit";

import { VideoEvents } from "../../globals";
import SubtitlesIcon from "./SubtitlesIcon";
import { useVideoElementRefContext } from "../../orca/contexts/VideoElementRefContext";
import "./index.css";

/**
 * Component which enables/disables the subtitles for the video.
 * @returns A button containing the closed caption icon.
 */

const PlaceholderElement = styled("div", {
  width: "40px",
  height: "40px"
});

export const SubtitlesButton = ({
  setShowSubtitles,
  playerState,
  hasSubtitles
}) => {
  const videoElementRef = useVideoElementRefContext();

  if (!hasSubtitles) {
    return <PlaceholderElement />;
  }

  return (
    <Button
      aria-label={
        playerState.showSubtitles ? "Hide subtitles" : "Show subtitles"
      }
      data-testid="subtitles-button"
      icon="center"
      className={"focus-visible-highlight"}
      variant="primary"
      css={{
        border: "none",
        paddingLeft: 0,
        background: "none",
        "&:hover": {
          background: "none"
        },
        margin: "-12px -12px 0 -12px",
        padding: "$075"
      }}
      onClick={e => {
        e.stopPropagation();
        const captionEvent = new Event(VideoEvents.CAPTIONS);
        videoElementRef.current.dispatchEvent(captionEvent);
        setShowSubtitles(!playerState.showSubtitles);
      }}
    >
      {playerState.showSubtitles ? (
        <SubtitlesIcon />
      ) : (
        <Icon fill="white" size="150" label="subtitles">
          <Cc />
        </Icon>
      )}
    </Button>
  );
};

SubtitlesButton.displayName = "SubtitlesButton";

SubtitlesButton.propTypes = {
  /* callback function to toggle subtitles state */
  setShowSubtitles: PropTypes.func,
  /* object tracking current video info*/
  playerState: PropTypes.object,
  /** Boolean to determine if the video has subtitles */
  hasSubtitles: PropTypes.bool
};
